import Image from 'next/image'
import Link from 'next/link'

import { FC } from 'react'

import { Affiliate } from '@/app/graphql/generated'
import { IconAirConditioning, IconLight, IconWifi } from '@/app/shared/icons'
import { ImagePosition } from '@/app/shared/images'

// interface
interface IPlace {
  data?: Affiliate | null
}

const generateIcon = (icon: string) => {
  switch (icon) {
    case 'light': {
      return <IconLight className={'h-full w-full'} />
    }
    case 'wifi': {
      return <IconWifi className={'h-full w-full'} />
    }
    case 'air-conditioning': {
      return <IconAirConditioning className={'h-full w-full'} />
    }
    default: {
      return null
    }
  }
}

const PlaceComponent: FC<Readonly<IPlace>> = ({ data }) => {
  return (
    <div
      className={
        'grid grid-cols-[110px_1fr] items-start gap-5 text-[10px] text-black extraMobile:grid-cols-[250px_1fr] laptop:grid-cols-[130px_1fr] desktop:grid-cols-[150px_1fr] large:grid-cols-[250px_1fr]'
      }
    >
      <div className={'relative h-28 extraMobile:h-48'}>
        <Image
          src={data?.image ?? ImagePosition}
          alt={'place'}
          fill
          className={'object-contain object-top'}
        />
      </div>
      <div className={'flex flex-col justify-between'}>
        {/*{!!data.isOpen && (*/}
        {/*  <div className={'relative mb-2.5 flex w-fit p-[7px_8px_20px_8px]'}>*/}
        {/*    <span className={'relative z-[1] text-[12px] font-extrabold uppercase text-primary'}>*/}
        {/*      відкрито*/}
        {/*    </span>*/}
        {/*    <IconBgDown className={'absolute left-0 top-0 h-full w-full text-warning'} />*/}
        {/*  </div>*/}
        {/*)}*/}
        <span className={'mb-1'}>{data?.address}</span>
        <ul className={'mb-2.5 grid gap-1'}>
          {data?.work_schedule?.split('\n').map((str: any) => (
            <li key={str} className={'text-content1-300'}>
              {str}
            </li>
          ))}
        </ul>
        <div className={'mb-2.5 grid gap-[10px]'}>
          <span>При відключеннях працює:</span>
          <ul className={'flex items-center'}>
            {['light', 'wifi', 'air-conditioning'].map((str: any) => (
              <li key={str} className={'mr-[15px] h-full max-h-5 w-auto'}>
                {generateIcon(str)}
              </li>
            ))}
          </ul>
        </div>
        <Link
          href={data?.url ?? 'https://google.com'}
          target={'_blank'}
          className={'mt-auto text-xs text-secondary'}
        >
          Прокласти маршрут
        </Link>
      </div>
    </div>
  )
}

export default PlaceComponent
